import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ResultsCard from "@/components/ResultsCard";
import { useStudentSession } from "@/hooks/useStudentSession";
import type { CompleteGameSessionResult } from "@/types/game";

export default function StudentResultsPage() {
  const nav = useNavigate();
  const { student } = useStudentSession();
  const [result, setResult] = useState<CompleteGameSessionResult | null>(null);

  useEffect(() => {
    const raw = sessionStorage.getItem("weldquest.lastResult");
    if (!raw) { nav("/student/register", { replace: true }); return; }
    try { setResult(JSON.parse(raw) as CompleteGameSessionResult); }
    catch { nav("/student/register", { replace: true }); }
  }, [nav]);

  if (!result || !student) return null;

  return (
    <main className="min-h-screen px-4 py-8 flex items-center justify-center">
      <ResultsCard
        result={result}
        studentName={student.full_name}
        schoolName={student.school_name}
      />
    </main>
  );
}
